import React from "react";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import AccountSettings from "./AccountSettings/AccountSettings";
import QuotaManagementRoot from "./QuotaMaintainence/QuotaManagementRootV2";
import UserManagementSection from "./UserManagement/UserManagement";

const styles = (theme) => ({
  dashOuter: {
    display: "flex",
    flexGrow: 1,
    margin: "auto",
  },
  dashInner: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
  },
  graph1: {
    flexGrow: 1,
    height: 250,
    margin: 10,
  },
});

const SettingsRoutes = (props) => {
  const { classes } = props;

  return (
    <>
      {props.location === "Change Password" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <AccountSettings />
          </Grid>
        </Grid>
      )}
      {props.location === "Quota Maintenance" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <QuotaManagementRoot />
          </Grid>
        </Grid>
      )}
      {props.location === "User Management" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <UserManagementSection />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default withStyles(styles)(SettingsRoutes);
